import { getRules, getMultiComplexRules } from './rules'
import Input from '../components/Input/Input'
import InputTime from '../components/Input/InputTime'
import InputNumber from '../components/Input/InputNumber'
import InputTaoSirForm from '../components/Input/InputTaoSirForm'
import Checkbox from '../components/Checkbox'
import SingleCheck from '../components/Checkbox/SingleCheck'
import Radio from '../components/Radio'
import MultiComplexItem from '../components/MultiComplexItem/index.vue'
import ComplexItem from '../components/ComplexItem'
import CatProp from '../components/ComplexItem/CatProp'
import Specification from '../components/ComplexItem/Specification'
import SalePropTable from '../components/ComplexItem/SalePropTable'
import PriceRange from '../components/ComplexItem/PriceRange'
import LogisticsWeightTable from '../components/ComplexItem/LogisticsWeightTable'
import GroupImages from '../components/ComplexItem/GroupImages'
import Images from '../components/ComplexItem/Images'
import VideoUpload from '../components/ComplexItem/VideoUpload'
import Image from '../components/Upload/Image'
import Select from '../components/Select'
import Editor from '../components/Editor'
import MultiEnum from '../components/MultiEnum/index.vue'
import store from '@/store'
import { genIsShowFn } from './disableRule'

// 区间报价的isShowFn
function _globalPriceRangeShowFn(alibabaForm) {
    return alibabaForm.quotationType == '2'
}
// // 发货时间天数的isShowFn
// function _alibabaDeliveryTimeShowFn(alibabaForm) {
//     return alibabaForm.deliveryTimeType === '2'
// }
// // 发货时间天数的isShowFn
// function _deliveryTimeSetBySkuShowFn(alibabaForm) {
//     return alibabaForm.deliveryTimeType === '2' && window._globel_vm?.$store.getters.alibabaData?.pureType !== 1
// }


export const needLimitImgFields = ['primaryPicture', 'verticalImage', 'threeToFourImages'];
// 一些图片的限制生成
function _genImagesLimit(item) {
    // 若不是需要处理的图片字段就不处理了
    if (!needLimitImgFields.includes(item.name)) {
        return {}
    }
    // 生成符合图片上传组件适用的属性
    let limits = {
        limitWidth: [0, 0],
        limitHeight: [0, 0],
        limitSize: 3 * 1024 * 1024,
        _needLimit: true
    }
    let { maxTargetSizeRule, maxImageSizeRule, minImageSizeRule, tipRule } = item._oriRules || {}
    if (maxTargetSizeRule) {
        limits.limitSize = Number(maxTargetSizeRule)
    }
    if (maxImageSizeRule) {
        let maxS = maxImageSizeRule.split('x')
        limits.limitHeight[1] = maxS[1]
        limits.limitWidth[1] = maxS[0]
    }
    if (minImageSizeRule) {
        let minS = minImageSizeRule.split('x')
        limits.limitHeight[0] = minS[1]
        limits.limitWidth[0] = minS[0]
    }
    if (tipRule) {
        // 有些图片限制需要通过tipRule描述，如比例
        // 一些正则匹配
        let regAspectRatio = /横竖比必须为(\d+：\d+)/
        let regMinWidth = /最小长度为(\d+)/

        // 匹配比例 
        let aspectRatio = tipRule.match(regAspectRatio);
        if (aspectRatio) {
            aspectRatio = aspectRatio[1];
            let _asp = aspectRatio.split('：')
            limits.aspectRatio = _asp[0] / _asp[1]
            limits.aspectRatioText = aspectRatio
        }

        // 匹配最小宽度
        let minWidth = tipRule.match(regMinWidth)
        if (minWidth) {
            minWidth = minWidth[1]
            limits.limitWidth[0] = minWidth
        }

    }

    if(item.name === 'primaryPicture') { // 主图支持AI重试
        limits.supportAiRetry = true
    }
    return limits
}

// 一些表单控件的展现需要依赖另一些 （生成isShowFn方法)
// 有些控件的提示语需要根据值来渲染 （生产isShowTipFn方法)
function _genIsShowFn(item) {
    if (item.name === "priceRange") {
        item.isShowFn = _globalPriceRangeShowFn
    } else if (item.name === "beginAmount") {
        item._suffixTextFn = (alibabaForm) => {
            alibabaForm = alibabaForm || store.getters.alibabaForm
            return alibabaForm.cbuUnit || ''
        }
    } else if(item.name === 'kf') {
        item.disabledFn = (alibabaForm) => {
            alibabaForm = alibabaForm || store.getters.alibabaForm
            const disabled = !((alibabaForm.supplyType || []).includes('2') && alibabaForm.isSupportQuickBackInventory)
            return disabled
        }
    }
    return item
}

/**
 * 是否用 checkbox 组件
 * @param {*} item 
 * @returns 
 */
const isCheckbox = (item) => {
    const { name, options } = item
    if (options?.length === 2) {
        const isTrue = options.some(item => item.value === '1' && item.displayName === '是') &&
            options.some(item => item.value === '0' && item.displayName === '否') && !item.rules.some(item => item.required)
        return isTrue;
    }
    return false;
}

const typeMap = {
    // INPUT，说明当前field的值为文本输入型。
    INPUT: item => {
        const { valueTypeRule, properties, name, parentName, _oriRules } = item
        // 特殊处理
        // name 为 "description" || "wirelessDesc"
        // 这两个为富文本输入，对应PC端详情与移动端详情
        if (["description"].includes(name)) {
            return {
                component: Editor,
                props: { dataSource: item, name, parentName }
            }
        }

        if (Array.isArray(properties) && properties.length > 0) {
            if (properties[0].type === 'taoSirProperty') { // 判断是否为度量衡属性
                return {
                    component: InputTaoSirForm,
                    props: { dataSource: item, name, parentName }
                }
            } else {
                return {
                    component: Input,
                    props: { dataSource: item, name, parentName }
                }
            }

        } else if (valueTypeRule === 'decimal') {
            return {
                component: InputNumber,
                props: { min: 0, precision: 2, name, parentName }
            }
        } else if (valueTypeRule === 'integer') {
            return { component: InputNumber, props: { min: 1, precision: 0, name, parentName } }
        } else if (valueTypeRule === 'url') {
            return {
                component: Input,
                props: { name, parentName }
            }
        } else if (valueTypeRule === 'date') {
            return {
                component: InputTime,
                props: {
                    style: {
                        width: '100%'
                    },
                    name,
                    parentName
                }
            }
        } else if (valueTypeRule === 'time') {
            return {
                component: InputTime,
                props: {
                    style: {
                        width: '100%'
                    },
                    format: 'YYYY-MM-DD HH:mm:ss',
                    showTime: { defaultValue: moment('00:00:00', 'HH:mm:ss') },
                    name,
                    parentName
                }
            }
        } else {
            return {
                component: Input,
                props: {
                    dataSource: _genIsShowFn(item),
                    placeholder: '请输入',
                    name,
                    parentName,
                    append: _oriRules.unitTypeRule
                },
            }
        }
    },
    // MULTIINPUT ，说明当前field的值为多行文本输入型。
    MULTIINPUT: item => {
        const { name } = item
        return { component: Input, props: { name } }
    },
    // SINGLECHECK，说明当前field的值为单选输入型，类似于radio。
    SINGLECHECK: item => {
        let { options, name, parentName, tipRule, _oriRules } = item
        if (name === 'startTime') {
            item.options = options.filter(op => op.value != 1);  // 去除定时上架，暂不支持 
            if (tipRule && tipRule.length) {
                item.tipRule = tipRule.filter(tr => tr !== '定时上架的商品在上架前请到“仓库中的宝贝”里编辑商品。');
            }
        }
        if (parentName && parentName === 'catProp') {
            // 类目属性下的子控件都转为下拉框
            return { component: Select, props: { dataSource: item, name, "value-key": "value", style: "width:100%;", canInputCustom: _oriRules?.customizable === 'true', clearNoExistValue: true } }
        } else if (isCheckbox(item)) {
            return { component: SingleCheck, props: { dataSource: _genIsShowFn(item), name, label: 's' } }
        } else {
            return { component: Select, props: { dataSource: _genIsShowFn(item), name, canInputCustom: _oriRules?.customizable === 'true' } }
        }
    },
    // CHECKBOX
    CHECKBOX: item => {
        const { options, name, parentName, tipRule } = item
        return { component: Radio, props: { dataSource: _genIsShowFn(item), name } }
    },
    // MULTICHECK ，说明当前field的值为多选输入型，类似于checkbox。
    MULTICHECK: item => {
        const { options, name, parentName, _oriRules } = item
        // multi_enum 类型：材质成分等多选+枚举值的特殊字段
        if (_oriRules?.valueTypeRule === 'multi_enum' && parentName === 'catProp') {
            return { component: MultiEnum, props: { dataSource: item, name, "value-key": "value", style: "width:100%;" } }
        }
        if (parentName && parentName === 'catProp') {
            // 类目属性下的子控件都转为下拉框
            return { component: Select, props: { dataSource: item, multiple: true, name, "value-key": "value", style: "width:100%;", canInputCustom: _oriRules?.customizable === 'true', clearNoExistValue: true } }
        } else {
            return { component: Checkbox, props: { dataSource: item, name } }
        }
    },
    // COMPLEX ，说明当前field的值为复合结构，表示数据的聚合。
    COMPLEX: item => {
        const { name, parentName } = item
        // 特殊处理几种复合型控件
        // 1. catProp 为类目属性
        // 2. saleProp 为销售属性（同其他平台的规格信息）
        // 3. salePropTable 为销售属性（工业类目的产品规格） 
        // 4. images 为主图+宝贝图+白底图（同其他主图组件，至于区分主图、宝贝图、白底图交由后端发布时后端处理）
        // 5. verticalImage 为长图，也用images的组件，在组件里作name的区别判断
        const specialCompMap = {
            catProp: CatProp,
            saleProp: Specification,
            salePropTable: SalePropTable,
            primaryPicture: Images,
            priceRange: PriceRange,
            logisticsWeightTable: LogisticsWeightTable,
            useGroupImages: GroupImages,
            upshelfTime: Radio,
            primaryVideo: VideoUpload,
            detailVideo: VideoUpload,
        }
        // 特殊处理
        // name 为 "desc" || "wirelessDesc"
        // 这两个为富文本输入，对应PC端详情与移动端详情
        if (["description"].includes(name)) {
            return {
                component: Editor,
                props: { dataSource: item, name, parentName }
            }
        }
        const otherParams = {};
        let imgAttr = {};
        if (name === 'saleProp') {
            imgAttr = item.imgRules;
        }

        if (needLimitImgFields.includes(name)) {
            otherParams['showAuditResult'] = true;
        }
        return {
            component: specialCompMap[name] || ComplexItem,
            props: {
                dataSource: _genIsShowFn(item),
                name,
                imgAttr,
                extraAttr: {
                    ..._genImagesLimit(item),
                    ...otherParams,
                },
            }
        }
    },
    // MULTICOMPLEX ，说明当前field的值为复合结构，与complex有差别的在于multiComplex的field是可以有多份数据实例样本。
    MULTICOMPLEX: item => {
        const { name } = item
        return { component: MultiComplexItem, props: { dataSource: item, name } }
    }
}

/**
 * 生成field
 * @param {*} fields 
 * @returns 
 */
const generateField = (fields, parentName) => {
    return fields.reduce((field, item) => {
        if (item.children) {
            item.children = generateField(item.children, item.name)
        }
        parentName && (item.parentName = parentName)
        item.rules = item.type === 'MULTICOMPLEX' ? getMultiComplexRules(item) : getRules(item) // rule
        // console.log(item.name, item, '----item.name, item----')

        item.component = typeMap[item.type](item)
        return field.concat(item)
    }, [])
}


/**
 * 获取field
 * @param {*} fields 
 * @returns 
 */
export const getField = (fields) => {
    if (!Array.isArray(fields) || fields.length <= 0) return []
    return generateField(fields)
}